const API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:5000/api' 
  : 'https://maya-backend-m1qw.onrender.com/api';

export default API_BASE_URL; 